const Birthday  = () => import('@/views/ADMIN/Birthday.vue')

export const birthdayList = {
  path: "/birthdays",
  name: "Birthday",
  meta: { requiresAuth: true},
  component: Birthday
};
